import React from 'react';
import styles from './Footer.module.css';

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        
        <div className={styles.footerContent}>
          <div className={styles.disclaimer}>
          <p className={styles.disclaimerText}>
            万盘搜仅提供搜索服务，不存储、上传或分发任何网盘内容。所有资源均来自第三方网盘，如发现任何侵权内容，请发送邮件至 <a href="mailto:market@aicosmos.cn">market@aicosmos.cn</a>，我们将及时处理。
          </p>
        </div>
          <div className={styles.copyright}>
            © {new Date().getFullYear()} 万盘搜. All rights reserved.
          </div>
          {/* <div className={styles.beian}>
            <a
              href="https://beian.miit.gov.cn/"
              target="_blank"
              rel="noopener noreferrer"
            >
              粤ICP备2024288585号
            </a>
          </div> */}
        </div>
      </div>
    </footer>
  );
};

export default Footer;
